module.exports = __webpack_public_path__ + "img/project-blog-1.18c1ae50.png";